import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import CheckboxInput from '../../../../../../../components/form/CheckboxInput'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'

const ValidationCodeSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChangeOnPath } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  if (selectedQuestion?.questionType?.name !== 'validation_code') return false

  return (
    <>
      <Separator weight={6} />
      <Title size="h6" color={COLORS.dark4}>
        {t('validationCode.title')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />

      <CheckboxInput
        label={t('validationCode.validateWithParentId')}
        value={!!selectedQuestion?.data?.validateWithParentId}
        onChange={handleSelectedQuestionChangeOnPath(['data', 'validateWithParentId'])}
      />
    </>
  )
}

export default ValidationCodeSection
